// Lib
import { createAction } from '@reduxjs/toolkit';

export const GetSharedKitsSettings = createAction('GET_SHARED_KITS_SETTINGS');
export const SetSharedKitsSettings = createAction('SET_SHARED_KITS_SETTINGS');
export const GetSharedKitMessages = createAction('GET_SHARED_KIT_MESSAGES');
export const SetSharedKitMessages = createAction('SET_SHARED_KIT_MESSAGES');
export const GetSharedKits = createAction('GET_SHARED_KITS');
export const SetSharedKits = createAction('SET_SHARED_KITS');
export const GetSharedKitDetails = createAction('GET_SHARED_KIT_DETAILS');
export const SetSharedKitDetails = createAction('SET_SHARED_KIT_DETAILS');
export const ClearSharedKitDetails = createAction('CLEAR_SHARED_KIT_DETAILS');
export const CreateSharedKit = createAction('CREATE_SHARED_KIT');
export const SetSharedKitProducts = createAction('SET_SHARED_KIT_PRODUCTS');
export const UpdateSharedKitItems = createAction('UPDATE_SHARED_KIT_ITEMS');
export const UpdateSharedKit = createAction('UPDATE_SHARED_KIT');
export const DeleteSharedKit = createAction('DELETE_SHARED_KIT');
export const AddSharedKitToCart = createAction('ADD_SHARED_KIT_TO_CART');
export const SetSharedKitActionError = createAction(
  'SET_SHARED_KIT_ACTION_ERROR',
);
export const CleanSharedKitActionError = createAction(
  'CLEAN_SHARED_KIT_ACTION_ERROR',
);
